const APIS = {
  PAYMENT_METHOD: "logisticservice/api/payment-method/",
  BRANCH: "/logisticservice/api/branch/",
  LOCATION: "logisticservice/api/location/",
  STAFF: "/usermanagementservice/api/user/",
  COMMENT: "/commentservice/api/comment/",
  ORDER_HISTORY: "/historyservice/api/history/",
  RECEIVER_DETAIL: "/logisticservice/api/receiver-detail/",
  STATUS: "logisticservice/api/status/",
  RUNSHEET: "/runsheetservice/api/runsheet/order-runsheet/",
  INVOICE: "/invoiceservice/api/merchant-invoice/invoice-id/",
  RIDER: "fleetservice/api/driver/",
  MERCHANT: "logisticservice/api/merchant/",
  ORDER: "logisticservice/api/order/",
  CACHE: "/cacheservice/api/invalidate-cache/",
};

export default APIS;
